exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "md-icon {\n  font-size: 150%; }\n\n.list-filters mat-form-field.datepicker {\n  width: 100px; }\n\nmat-table mat-cell:first-child {\n  max-width: 80px; }\n\nmat-table .badge.badge-pill.confirmed {\n  background-color: #dc3545; }\n\nmat-table .badge.badge-pill.dispatched {\n  background-color: coral; }\n\nmat-table .badge.badge-pill.in_dispatch {\n  background-color: #9d00db; }\n\nmat-table .badge.badge-pill.returned {\n  background-color: lightgreen; }\n\nmat-table .badge.badge-pill.cancelled {\n  background-color: #000; }\n\nmat-table .badge.badge-pill.handed {\n  background-color: #b85d5d; }\n\nmat-table .badge.badge-pill.picked {\n  background-color: #3a7db9; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/ContractsModule/ContractsListComponent/contracts-list.component.scss
// module id = ../../../../../src/ContractsModule/ContractsListComponent/contracts-list.component.scss
// module chunks = main